(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(() => {
  const seen = new WeakSet();
  const jobs = new WeakMap();
  const selector = 'script[data-tyrot-sale-page]';

  function read(marker) {
    const data = JSON.parse(marker.textContent);
    const grid = marker.parentElement;
    const cards = new Map();
    for (const card of grid.querySelectorAll(':scope > [data-product-options]')) {
      const id = String(JSON.parse(card.dataset.productOptions).id);
      cards.set(id, card);
    }
    return { data, cards };
  }

  async function sort(marker) {
    if (seen.has(marker)) return;
    seen.add(marker);
    const grid = marker.parentElement;
    const section = grid.closest('.shopify-section');
    const current = read(marker);
    if (current.data.sort !== 'manual') return;
    jobs.get(section)?.abort();
    const controller = new AbortController();
    jobs.set(section, controller);
    const { signal } = controller;
    const timeout = setTimeout(() => controller.abort(), 20000);
    const pages = new Map([[current.data.page, current]]);
    const pending = Array.from({ length: current.data.pages }, (_, i) => i + 1)
      .filter(page => page !== current.data.page);
    const status = document.createElement('p');
    status.setAttribute('role', 'status');
    status.textContent = current.data.loading;
    grid.before(status);
    grid.setAttribute('aria-busy', 'true');
    try {
      const base = new URL(current.data.page_url || location.href, location.origin);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) base.searchParams.set('preview_theme_id', preview);
      await Promise.all(Array.from({ length: Math.min(3, pending.length) }, async () => {
        while (pending.length) {
          const page = pending.shift();
          const url = new URL(base);
          url.searchParams.set('page', String(page));
          url.searchParams.set('section_id', current.data.section);
          const response = await fetch(url, { signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Sale page unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const next = html.querySelector(selector);
          if (!next) throw new Error('Sale page metadata unavailable');
          const result = read(next);
          if (result.data.page !== page || result.data.pages !== current.data.pages ||
              result.data.total !== current.data.total) throw new Error('Sale collection changed');
          pages.set(page, result);
        }
      }));
      if (!marker.isConnected || signal.aborted || jobs.get(section) !== controller) return;
      const items = [];
      const ids = new Set();
      for (let page = 1; page <= current.data.pages; page++) {
        const result = pages.get(page);
        for (const item of result.data.items) {
          const card = result.cards.get(String(item.id));
          if (!card || ids.has(String(item.id))) throw new Error('Sale collection changed');
          ids.add(String(item.id));
          items.push({ ...item, card, position: items.length });
        }
      }
      if (items.length !== current.data.total) throw new Error('Sale collection changed');
      items.sort((a, b) => b.discount - a.discount || a.position - b.position);
      const start = (current.data.page - 1) * current.data.size;
      const chosen = items.slice(start, start + current.data.size);
      grid.replaceChildren(marker, ...chosen.map(item => item.card));
      if (typeof window.T4SThemeSP?.reinitProductGridItem === 'function') {
        window.T4SThemeSP.reinitProductGridItem();
      }
      window.dispatchEvent(new Event('resize'));
      status.remove();
    } catch (error) {
      if (marker.isConnected && jobs.get(section) === controller) {
        status.textContent = current.data.failed;
      } else status.remove();
    } finally {
      clearTimeout(timeout);
      grid.removeAttribute('aria-busy');
    }
  }

  function scan() {
    document.querySelectorAll(selector).forEach(marker => {
      sort(marker).catch(() => {});
    });
  }
  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tyrot-flore-material"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tyrot-flore-material')) {
    customElements.define('tyrot-flore-material', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.requestVersion = 0;
        this.pendingImageCancels = new Set();
        this.variantColors = JSON.parse(this.querySelector('[data-flore-variants]').textContent);
        this.display = this.querySelector('[data-flore-display]');
        this.status = this.querySelector('[data-flore-status]');
        this.retry = this.querySelector('[data-flore-retry]');
        this.groups = new Map();
        this.blockColors = new Map();
        const current = this.display.querySelector(':scope > [data-flore-color]');
        if (!current) return;
        this.currentColor = this.normalize(current.dataset.floreColor);
        this.requestedColor = this.currentColor;
        this.rememberGroup(current);
        this.querySelectorAll('[data-flore-template]').forEach(template => {
          this.rememberGroup(template.content.firstElementChild);
          this.append(template);
        });
        this.onVariant = (event, payload) => {
          const origin = event.target instanceof Element ? event.target.closest('[data-product-featured]') : null;
          if (origin && this.productScope && origin !== this.productScope) return;
          const variant = payload?.currentVariant || event.currentVariant || event.detail?.currentVariant || event.detail?.variant;
          if (variant?.id) this.showVariant(variant.id);
        };
        const signal = this.controller.signal;
        this.retry.addEventListener('click', () => this.showColor(this.retryColor), { signal });
        document.addEventListener('variant:changed', this.onVariant, { signal });
        window.addEventListener('popstate', () => this.syncFromUrl(), { signal });
        document.addEventListener('shopify:block:select', event => {
          const color = this.blockColors.get(event.detail?.blockId);
          if (color) this.showColor(color);
        }, { signal });
        document.addEventListener('shopify:block:deselect', event => {
          if (this.blockColors.has(event.detail?.blockId)) this.syncFromForm();
        }, { signal });
        document.addEventListener('shopify:section:unload', event => {
          if (event.detail?.sectionId === this.dataset.sectionId) this.disconnect();
        }, { signal });
        this.attachTheme();
        document.addEventListener('DOMContentLoaded', () => this.attachTheme(), { once: true, signal });
        window.addEventListener('load', () => this.attachTheme(), { once: true, signal });
        this.attachTimers = [250, 1000, 2500].map(delay => setTimeout(() => this.attachTheme(), delay));
      }

      normalize(value) { return String(value || '').trim().toLowerCase(); }

      rememberGroup(group) {
        if (!group) return;
        const color = this.normalize(group.dataset.floreColor);
        this.groups.set(color, group.cloneNode(true));
        this.blockColors.set(group.dataset.floreBlock, color);
      }

      attachTheme() {
        if (!this.isConnected || !this.controller) return;
        if (!this.jquery) {
          this.jquery = window.jQuery_T4NT || window.jQuery;
          if (this.jquery) this.jquery(document).on('variant:changed', this.onVariant);
        }
        if (this.productForm) return;
        for (const candidate of document.querySelectorAll('[data-product-featured]')) {
          try {
            const config = JSON.parse(candidate.getAttribute('data-product-featured'));
            if (String(config.id) === this.dataset.productId && config.isMainProduct) {
              this.productScope = candidate;
              this.productForm = config.formID ? document.querySelector(config.formID) : candidate.querySelector('form[action*="/cart/add"]');
              break;
            }
          } catch (error) {}
        }
        if (!this.productForm) return;
        this.productForm.addEventListener('change', event => {
          if (event.target.name === 'id') this.showVariant(event.target.value);
        }, { signal: this.controller.signal });
        this.formObserver = new MutationObserver(() => this.syncFromForm());
        this.formObserver.observe(this.productForm, { subtree: true, attributes: true, attributeFilter: ['selected', 'value', 'variant-id', 'data-variant-id'] });
        this.syncFromForm();
      }

      syncFromForm() {
        const select = this.productForm?.querySelector('select[name="id"]');
        const input = select?.value && this.variantColors[String(select.value)] ? select : [...(this.productForm?.querySelectorAll('input[name="id"]') || [])].find(candidate => this.variantColors[String(candidate.value)]);
        if (input?.value && this.variantColors[String(input.value)]) this.showVariant(input.value);
      }

      syncFromUrl() {
        this.showVariant(new URL(window.location.href).searchParams.get('variant') || this.dataset.defaultVariantId);
      }

      showVariant(id) {
        const color = this.variantColors[String(id)];
        if (color) this.showColor(color);
      }

      async showColor(value) {
        const color = this.normalize(value);
        if (!this.groups.has(color) || color === this.requestedColor) return;
        this.requestedColor = color;
        this.retryColor = value;
        const version = ++this.requestVersion;
        if (color === this.currentColor) {
          this.setState('idle');
          return;
        }
        const group = this.ownerDocument.importNode(this.groups.get(color), true);
        const rect = this.display.getBoundingClientRect();
        const visible = rect.top < window.innerHeight && rect.bottom > 0;
        if (visible) {
          this.setState('loading', group.dataset.floreColor);
          const loaded = await Promise.all([...group.querySelectorAll('img')].map(image => this.prepareImage(image)));
          if (version !== this.requestVersion || !this.isConnected) return;
          if (loaded.some(result => !result)) {
            this.requestedColor = null;
            this.setState('error', group.dataset.floreColor);
            return;
          }
        }
        if (version !== this.requestVersion || !this.isConnected) return;
        this.display.replaceChildren(group);
        this.currentColor = color;
        this.setState('idle', group.dataset.floreColor);
      }

      setState(state, color) {
        this.dataset.floreState = state;
        this.display.setAttribute('aria-busy', String(state === 'loading'));
        this.retry.hidden = state !== 'error';
        const message = state === 'loading' ? this.dataset.loadingMessage : state === 'error' ? this.dataset.errorMessage : this.dataset.updatedMessage;
        this.status.textContent = color ? message.replace('__color__', color) : '';
      }

      prepareImage(image) {
        return new Promise(resolve => {
          let finished = false;
          const finish = success => {
            if (finished) return;
            finished = true;
            clearTimeout(timeout);
            this.pendingImageCancels.delete(cancel);
            image.removeEventListener('load', loaded);
            image.removeEventListener('error', failed);
            resolve(success);
          };
          const loaded = () => {
            if (image.decode) image.decode().then(() => finish(true)).catch(() => finish(image.naturalWidth > 0));
            else finish(true);
          };
          const failed = () => finish(false);
          const cancel = () => finish(false);
          this.pendingImageCancels.add(cancel);
          const timeout = setTimeout(() => finish(false), 12000);
          image.addEventListener('load', loaded, { once: true });
          image.addEventListener('error', failed, { once: true });
          image.loading = 'eager';
          if (image.complete && image.naturalWidth > 0) loaded();
        });
      }

      disconnectedCallback() { this.disconnect(); }

      disconnect() {
        ++this.requestVersion;
        this.controller?.abort();
        this.formObserver?.disconnect();
        this.pendingImageCancels?.forEach(cancel => cancel());
        this.jquery?.(document).off('variant:changed', this.onVariant);
        this.attachTimers?.forEach(clearTimeout);
        this.controller = null;
        this.jquery = null;
        this.productForm = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tyrot-holiday"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('holiday-edit')) {
  customElements.define('holiday-edit', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const grid = this.querySelector('.ty-holiday__products');
      const cards = Array.from(grid.children);
      const controls = this.querySelector('[data-controls]');
      controls.hidden = false;
      this.querySelectorAll('[data-filter]').forEach(button => {
        if (button.dataset.filter !== 'all' && !cards.some(card => card.dataset.category === button.dataset.filter)) button.hidden = true;
        button.addEventListener('click', () => {
          this.querySelectorAll('[data-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          cards.forEach(card => { card.hidden = button.dataset.filter !== 'all' && card.dataset.category !== button.dataset.filter; });
          const count = cards.filter(card => !card.hidden).length;
          this.querySelector('.ty-holiday__count').textContent = count + (count === 1 ? ' product' : ' products');
        });
      });
      this.querySelector('select').addEventListener('change', event => {
        const mode = event.target.value;
        cards.sort((a,b) => mode === 'featured' ? Number(a.dataset.order)-Number(b.dataset.order) : (Number(a.dataset.price)-Number(b.dataset.price)) * (mode === 'ascending' ? 1 : -1));
        cards.forEach(card => grid.appendChild(card));
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
